import AppListing from '../app-components/Listing/AppListing';

Vue.component('app-finance-listing', {
    mixins: [AppListing],
    props:{
        userOffice:{
            type: Object,
            default: ()=>({})
        }
    },
    data: function () {  
        return {
            showFilter: false,
            moduleFilters:{
                app_offices_id: null,
                app_factories_id: null,
                date_start: null,
                date_end: null,
                type: null,
            },
            tempOffice: null,
            tempFactory: null,
            tempType: null,
            testDate: null,
            UrlDownloadFinanceReport: null,
        }
    },
    methods:{
        onSelectOffice: function (office) { 
            this.tempOffice = office
            this.moduleFilters.app_offices_id = (office==null)? null: office.id
            this.applyFilters()
        },
        onSelectFactory: function (factory) { 
            this.tempFactory = factory
            this.moduleFilters.app_factories_id = (factory==null)? null: factory.id
            this.applyFilters()
        },
        getFileName(){
            return this.getListingFileName('daftar_transaksi_keuangan')
        },
        onUpdateType(item){
            console.log('item', item)
            this.moduleFilters.type=item.id
            this.applyFilters()
        },
        onRemoveType(){
            this.moduleFilters.type=null
            this.applyFilters()
        },
        isAllowEdit(type){
            return [
                'make_debt_staff',
                'pay_debt_staff',
                'const',
                'modal',
                'income',
                'transfer_modal'
            ].includes(type)
        },
        isAllowDelete(type){
            return [
                // 'make_debt_staff',
                // 'pay_debt_staff',
                'const',
                'modal',
                'income',
            ].includes(type)
        },
        buildUrlDownloadFinanceReport(){
            const baseUrl = this.url
            var options = {
                params: {
                    per_page: this.perPageDownload,
                    page: 1,
                    orderBy: this.orderBy.column,
                    orderDirection: this.orderBy.direction,
                    action: 'to-excel',
                }
            };
            
            Object.assign(options.params, this.filterObject(this.filters, function (val, key) { return val !== null }));
            Object.assign(options.params, this.filterObject(this.moduleFilters, function (val, key) { return val !== null }));
            const queryString = '?' + new URLSearchParams(options.params).toString();
            this.UrlDownloadFinanceReport = baseUrl+queryString;
        },
        applyFilters(){
            // console.log('this.moduleFilters', this.moduleFilters)
            Object.assign(this.filters, this.moduleFilters);
            this.buildUrlDownloadFinanceReport()
            // console.log('this.filters', this.filters)
            this.loadData(true)
        },
        DownloadFinanceReport(){
            this.buildUrlDownloadFinanceReport()
            this.openUrl(this.UrlDownloadFinanceReport)
        },
        filterSearch (value) {
            if (this.$_debounceTimer !== null) {
                console.log('clear', this.$_debounceTimer, value)
                clearTimeout(this.$_debounceTimer)
                console.log('result clear', this.$_debounceTimer, value)
            }
            console.log('set ruuning filter', this.$_debounceTimer, value)
            this.$_debounceTimer = setTimeout(() => {
                console.log('running filter', this.$_debounceTimer, value)
                this.filter('search', value)
            }, 1000)
        }
       
    },
    
    mounted: function () {  
        this.onSelectOffice(this.userOffice)
        this.buildUrlDownloadFinanceReport()
    }
});